import { Divider, MenuItem } from '@mui/material';
import { Fragment, useMemo } from 'react';

import { Roles } from '@shared/constants/constants';
import { useUserAccount } from '@shared/hooks/useUserAccount';

import { DOC_GEN_LENDER_DROPPED_MENU, DOC_GEN_LENDER_MENU, DOC_GEN_TITLE_MENU, IDocsMenu, IDocsMenuProps } from './interface';

export const DocsMenu = ({ handleMenuItemClick, allowDroppedDocGenAndDocuSign = false }: IDocsMenuProps) => {
  const { isAdmin, userHasRoles } = useUserAccount();
  const isDocGenTitle = userHasRoles([Roles.DOC_GEN_TITLE]);
  const isDocGenLender = userHasRoles([Roles.DOC_GEN_LENDER]);

  const docGenLenderMenu = useMemo(() => {
    let lenderMenu = DOC_GEN_LENDER_MENU;
    lenderMenu[lenderMenu.length - 1] = {...lenderMenu[lenderMenu.length - 1], divider: !allowDroppedDocGenAndDocuSign};

    if (allowDroppedDocGenAndDocuSign) {
      lenderMenu = lenderMenu.concat(DOC_GEN_LENDER_DROPPED_MENU);
    }

    return lenderMenu;
  }, [allowDroppedDocGenAndDocuSign]);

  return (
    <>
      {(isDocGenLender || isAdmin) &&
        docGenLenderMenu.map((item: IDocsMenu) => (
          <Fragment key={'menuKey ' + item.id}>
            <MenuItem onClick={() => handleMenuItemClick(item)}>{item.name}</MenuItem>
            {item.divider ? <Divider sx={{ my: 0.5 }} /> : null}
          </Fragment>
        )
        )}
      {(isDocGenTitle || isAdmin) &&
        DOC_GEN_TITLE_MENU.map((item: IDocsMenu) => (
          <Fragment key={'menuKey ' + item.id}>
            <MenuItem onClick={() => handleMenuItemClick(item)}>{item.name}</MenuItem>
            {item.divider ? <Divider sx={{ my: 0.5 }} /> : null}
          </Fragment>
        ))}
    </>
  );
};
